import React from 'react';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import withStyles from '@material-ui/core/styles/withStyles';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  }
});

class Register extends React.Component {


    render() {
      const ITEM_HEIGHT = 48;
      const ITEM_PADDING_TOP = 8;
      const MenuProps = {
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
          },
        },
      };
    return (
      <React.Fragment>
        <CssBaseline />
          <AppBar position="absolute" color="default" className={this.props.classes.appBar}>
            <Toolbar>
              <Typography variant="title" color="inherit" noWrap>
                Audyssée
              </Typography>
            </Toolbar>
          </AppBar>
        <main className={this.props.classes.layout}>

          <Paper className={this.props.classes.paper}>
            <Typography variant="headline">Inscription</Typography>
            <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form}>
              <FormControl margin="normal" required fullWidth>
                  <TextValidator
                      label="Email"
                      onChange={this.props.handleInputChange}
                      name="email"
                      value={this.props.formData.email}
                      validators={['required', 'isEmail']}
                      errorMessages={['ce champ est requis', 'email is not valid']}
                  />
              </FormControl>
              <Grid container spacing={24}>
                <Grid item xs={6}>
                  <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="Prénom"
                          onChange={this.props.handleInputChange}
                          name="firstname"
                          value={this.props.formData.firstname}
                          validators={['required', 'matchRegexp:^[0-9A-Za-zàáâäçèéêëìíîïñòóôöùúûü-]*$']}
                          errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
                      />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="Nom"
                          onChange={this.props.handleInputChange}
                          name="surname"
                          value={this.props.formData.surname}
                          validators={['required', 'matchRegexp:^[0-9A-Za-zàáâäçèéêëìíîïñòóôöùúûü-]*$']}
                          errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
                      />
                  </FormControl>
                </Grid>
              </Grid>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="organisations">Organisation(s)</InputLabel>
                <Select
                  multiple
                  name="organisations"
                  value={this.props.formData.organisations}
                  onChange={this.props.handleInputChange}
                  input={<Input id="select-multiple-checkbox" />}
                  renderValue={(selected) => {
                    let names = selected.map((s) => {
                      let obj = this.props.listOfOrganisations.find(o => o.id === s)
                      return obj.name
                    })
                    return names.join(', ')
                  }}
                  MenuProps={MenuProps}
                >
                  {this.props.listOfOrganisations.map(organisation => (
                    <MenuItem key={organisation.name} value={organisation.id}>
                      <Checkbox checked={this.props.formData.organisations.indexOf(organisation.id) > -1} />
                      <ListItemText primary={organisation.name} />
                    </MenuItem>
                  ))}
                </Select>
                {(!this.props.valid) && <Typography color="error" gutterBottom noWrap>
                  {`Merci de sélectionner au minimum une organisation`}
                </Typography>}

              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <TextValidator
                    label="Password"
                    onChange={this.props.handleInputChange}
                    name="password"
                    type="password"
                    validators={['required', 'minStringLength:8', 'maxStringLength:64']}
                    errorMessages={['ce champ est requis', 'La taille du mot de passe doit être comprise entre 8 et 64 caractères', 'La taille du mot de passe doit être comprise entre 8 et 64 caractères']}
                    value={this.props.formData.password}
                />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <TextValidator
                    label="Repeat password"
                    onChange={this.props.handleInputChange}
                    name="repeatPassword"
                    type="password"
                    validators={['isPasswordMatch', 'required']}
                    errorMessages={['password mismatch', 'ce champ est requis']}
                    value={this.props.formData.repeatPassword}
                />
              </FormControl>
              <Button

                    type="submit"
                    fullWidth
                    variant="raised"
                    color="primary"
                    className={this.props.classes.submit}
                    disabled={this.props.submitted}
                >
                    {
                        (this.props.submitted && "Inscription en cours...") ||
                        (!this.props.submitted && "S'inscrire")
                    }
                </Button>
              <Divider inset />
              <Button  variant="outlined" href={null} onClick={this.props.toLogin} className={this.props.classes.button}>
                annuler
              </Button>
            </ValidatorForm>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

Register.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Register);



// WEBPACK FOOTER //
// ./src/component/auth/register.js